(function () {
  function tokens(value) {
    return (value || '').toLowerCase().split(/\s+/).filter(Boolean);
  }

  function setPressed(buttons, selected) {
    buttons.forEach(function (button) {
      var active = button === selected;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function initialise(root) {
    if (root.dataset.aureliaFilterReady === 'true') return;
    root.dataset.aureliaFilterReady = 'true';

    var categoryButtons = Array.from(root.querySelectorAll('[data-aurelia-category-filter]'));
    var sizeButtons = Array.from(root.querySelectorAll('[data-aurelia-size-filter]'));
    var count = root.querySelector('[data-aurelia-visible-count]');
    var total = root.querySelector('[data-aurelia-total-count]');
    var reset = root.querySelector('[data-aurelia-filter-reset]');
    var category = 'all';
    var size = 'all';

    function apply() {
      var cards = Array.from(root.querySelectorAll('product-card[data-aurelia-categories]'));
      var empty = root.querySelector('[data-aurelia-filter-empty]');
      var visible = 0;

      cards.forEach(function (card) {
        var categories = tokens(card.dataset.aureliaCategories);
        var sizes = tokens(card.dataset.aureliaSizes);
        var categoryMatch = category === 'all' || categories.indexOf(category) !== -1;
        var sizeMatch = size === 'all' || sizes.indexOf(size) !== -1;
        var show = categoryMatch && sizeMatch;

        card.hidden = !show;
        card.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) visible += 1;
      });

      if (count) count.textContent = String(visible);
      if (total) total.textContent = String(cards.length);
      if (empty) empty.classList.toggle('hidden', visible !== 0);
      if (reset) reset.hidden = category === 'all' && size === 'all';
    }

    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        category = button.dataset.aureliaCategoryFilter || 'all';
        setPressed(categoryButtons, button);
        apply();
      });
    });

    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        size = button.dataset.aureliaSizeFilter || 'all';
        setPressed(sizeButtons, button);
        apply();
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        category = 'all';
        size = 'all';
        setPressed(categoryButtons, categoryButtons[0]);
        setPressed(sizeButtons, sizeButtons[0]);
        apply();
      });
    }

    var gridContainer = root.querySelector('#ProductGridContainer');
    if (gridContainer) {
      new MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) { return mutation.type === 'childList'; })) apply();
      }).observe(gridContainer, { childList: true, subtree: true });
    }

    apply();
  }

  function initialiseAll() {
    document.querySelectorAll('[data-aurelia-filter-root]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll);
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
